var _class, _MappablePreview;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import defined from "terriajs-cesium/Source/Core/defined";
import { DataSourceAction } from "../../Core/AnalyticEvents/analyticEvents";
import MappableMixin from "../../ModelMixins/MappableMixin";
import toggleItemOnMapFromCatalog, { Op as ToggleOnMapOp } from "../DataCatalog/toggleItemOnMapFromCatalog";
import measureElement from "../HOCs/measureElement";
import SharePanel from "../Map/Panels/SharePanel/SharePanel";
import DataPreviewMap from "./DataPreviewMap";
import Description from "./Description";
import Styles from "./mappable-preview.scss";
import WarningBox from "./WarningBox";

/**
 * @typedef {object} Props
 * @prop {Terria} terria
 * @prop {MappableMixin.Instance} previewed
 * @prop {ViewState} viewState
 *
 */

/**
 * CatalogItem preview that is mappable (as opposed to say, an analytics item that can't be displayed on a map without
 * configuration of other parameters.
 * @extends {React.Component<Props>}
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let MappablePreview = observer(_class = (_MappablePreview = class MappablePreview extends Component {
  async toggleOnMap(event) {
    if (defined(this.props.viewState.storyShown)) {
      runInAction(() => this.props.viewState.storyShown = false);
    }
    const keepCatalogOpen = this.props.viewState.terria.configParameters.keepCatalogOpen || event.shiftKey || event.ctrlKey;
    await toggleItemOnMapFromCatalog(this.props.viewState, this.props.previewed, keepCatalogOpen, {
      [ToggleOnMapOp.Add]: DataSourceAction.addFromPreviewButton,
      [ToggleOnMapOp.Remove]: DataSourceAction.removeFromPreviewButton
    });
  }
  backToMap() {
    this.props.viewState.explorerPanelIsVisible = false;
  }
  render() {
    var _catalogItem$loadMeta, _catalogItem$loadMeta2, _catalogItem$loadMapI, _catalogItem$loadMapI2;
    const {
      t
    } = this.props;
    const catalogItem = this.props.previewed;
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.root,
      children: [MappableMixin.isMixedInto(catalogItem) && !catalogItem.disablePreview && /*#__PURE__*/_jsx(DataPreviewMap, {
        terria: this.props.terria,
        previewed: catalogItem,
        showMap: true
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: this.toggleOnMap.bind(this),
        className: Styles.btnAdd,
        children: this.props.terria.workbench.contains(catalogItem) ? t("preview.removeFromMap") : t("preview.addToMap")
      }), /*#__PURE__*/_jsxs("div", {
        className: Styles.previewedInfo,
        children: [/*#__PURE__*/_jsxs("div", {
          className: Styles.titleAndShareWrapper,
          ref: component => this.refToMeasure = component,
          children: [/*#__PURE__*/_jsx("h3", {
            className: Styles.h3,
            children: catalogItem.name
          }), !catalogItem.hasLocalData && !this.props.viewState.useSmallScreenInterface && /*#__PURE__*/_jsx("div", {
            className: Styles.shareLinkWrapper,
            children: /*#__PURE__*/_jsx(SharePanel, {
              catalogShare: true,
              catalogShareWithoutText: true,
              modalWidth: this.props.widthFromMeasureElementHOC,
              terria: this.props.terria,
              viewState: this.props.viewState
            })
          })]
        }), ((_catalogItem$loadMeta = catalogItem.loadMetadataResult) === null || _catalogItem$loadMeta === void 0 ? void 0 : _catalogItem$loadMeta.error) && /*#__PURE__*/_jsx(WarningBox, {
          error: (_catalogItem$loadMeta2 = catalogItem.loadMetadataResult) === null || _catalogItem$loadMeta2 === void 0 ? void 0 : _catalogItem$loadMeta2.error,
          viewState: this.props.viewState
        }), ((_catalogItem$loadMapI = catalogItem.loadMapItemsResult) === null || _catalogItem$loadMapI === void 0 ? void 0 : _catalogItem$loadMapI.error) && /*#__PURE__*/_jsx(WarningBox, {
          error: (_catalogItem$loadMapI2 = catalogItem.loadMapItemsResult) === null || _catalogItem$loadMapI2 === void 0 ? void 0 : _catalogItem$loadMapI2.error,
          viewState: this.props.viewState
        }), /*#__PURE__*/_jsx(Description, {
          item: catalogItem
        })]
      })]
    });
  }
}, _defineProperty(_MappablePreview, "propTypes", {
  previewed: PropTypes.object.isRequired,
  terria: PropTypes.object.isRequired,
  viewState: PropTypes.object.isRequired,
  widthFromMeasureElementHOC: PropTypes.number,
  t: PropTypes.func.isRequired
}), _MappablePreview)) || _class;
export default withTranslation()(measureElement(MappablePreview));